({
    var: {
        section_name: "acc-kb-mojostack-redesign-02",

    },
    classes: new Map([
        ['product-description-section', class xlr8dProductDescription extends HTMLElement {
            constructor(){
                super();
                let debounce=!1;
                this.addEventListener('change', function(){
                    clearTimeout(debounce);
                    debounce=setTimeout(this.subscriptionSwitch.bind(this),250);
                }.bind(this));
            }
            subscriptionSwitch(ev){
                let form=this.querySelector('form');
                if (!form) return;
                let onetime=/^\s*onetime\s*$/i.test(([...new FormData(form)].find(i=>/^selling_plan_/i.test(i[0]))||[])[1]);
                let select=this.querySelector('form select[name="selling_plan"]');
                if (!select) return;
                if (onetime) {
                    if (!(select.value||'').length) return;
                    select.value=null;
                    select.dispatchEvent(new Event('change'));
                    return;
                } else if (!(select.value||'').length) {
                    select.value=select.options[0].value;
                    select.dispatchEvent(new Event('change'));
                }
                let selling_plan=(new FormData(form)).get('selling_plan');
                if (!selling_plan) throw new Error('Form broken!');
                this.querySelectorAll('input[class*="-purchase-type-switch"]').forEach(input=>input.setAttribute('name',`selling_plan_${selling_plan}`));
            }
        }],
        ['image-slider', class xlr8dImageSlider extends HTMLElement {
            constructor(){
                super();
                let debounce=!1;
                let blocked=!1;
                let observer=new MutationObserver(()=>{
                    if (blocked) return;
                    clearTimeout(debounce);
                    debounce=setTimeout(function(){
                        blocked=!0;
                        observer.disconnect();
                        this.applyFlickity().catch(e=>console.warn(e));
                    }.bind(this),250);
                });
                observer.observe(this,{childList:!0});
            }
            async applyFlickity(){
                let settings;
                for (let wait=1; wait<40; wait++) {
                    if ((!!window.Flickity||!!(window.jQuery||(()=>({})))().flickity) && !!(settings=JSON.parse(this.dataset.sliderSettings))) break;
                    await new Promise(r=>setTimeout(r,250));
                }
                switch (!0) {
                    case !!window.Flickity:
                        this.flickity=new Flickity(this, settings);
                        break;
                    case !!(window.jQuery||(()=>({})))().flickity:
                        jQuery(this).flickity(settings);
                        break;
                    default:
                        throw new Error(`Flickity not loaded for slider-element ${this.nodeName}`);
                }
                let debounce=!1;
                window.addEventListener('resize',function(){
                    clearTimeout(debounce);
                    debounce=setTimeout(this.resizeSlider.bind(this),400+(Math.random()*600));
                }.bind(this));
            }
            resizeSlider() {
                switch (!0){
                    case !!window.Flickity && !!this.flickity:
                        this.flickity.resize();
                        break;
                    case !!window.jQuery && !!window.jQuery(this).flickity:
                        window.jQuery(this).flickity('resize');
                        break;
                    default:
                        break;
                }
            }
        }]
    ]),
    registerClasses(){
        for (let elementSuffix of this.classes.keys()) if (!window.customElements.get(`${this.var.section_name}-${elementSuffix}`)) window.customElements.define(`${this.var.section_name}-${elementSuffix}`, this.classes.get(elementSuffix));
    },
    async _() {
        window.DISABLE_RECHARGE = !0;
        this.registerClasses();
    }
})._().catch(e=>console.warn(e));